import { AnalysisType } from '../types/ecg.type';

export const isEcgAlreadyProcessed = (analysisType: AnalysisType) =>
  (['resting', 'rpm', 'mct'] as (keyof AnalysisType)[]).some(
    (type) => analysisType[type],
  );
